import { FAQSectionProps } from "@/types/faqs";

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { motion } from "framer-motion";
import FAQ from "@/components/faqs/faq/faq";

import faqStyles from "./Faqs.module.css";

const Faqs = ({ title, description, faqs }: FAQSectionProps) => {
	const parentFAQs = (faqs ?? []).filter((faq) => faq.faqCategory === "parents");
	const doulaFAQs = (faqs ?? []).filter((faq) => faq.faqCategory === "doulas");

	return (
		<section id="faq" className="py-20">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 xl:px-0">
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true }}
					className="text-center mb-12"
				>
					<h2 className="text-4xl lg:text-6xl font-light text-black font-karla mb-8 leading-tight lg:leading-10">
						{title}
					</h2>
					<p className="text-xl lg:text-[24px] text-black font-karla">
						{description}
					</p>
				</motion.div>

				<Tabs defaultValue="parents" className="w-full">
					<div className={`${faqStyles.tabButtons} max-w-md mx-auto border border-newTheme-lightGrey`}>
						<TabsList className="grid w-full grid-cols-2 bg-transparent p-0 h-auto">
							<TabsTrigger
								value="parents"
								className={`${faqStyles.tabButton} data-[state=active]:bg-newTheme-lime text-black data-[state=inactive]:opacity-50 transition-all duration-300 rounded-md m-0.5`}
							>
								For Parents
							</TabsTrigger>
							<TabsTrigger
								value="doulas"
								className={`${faqStyles.tabButton} data-[state=active]:bg-newTheme-lime text-black data-[state=inactive]:opacity-50 transition-all duration-300 rounded-md m-0.5`}
							>
								For Doulas
							</TabsTrigger>
						</TabsList>
					</div>

					<FAQ faqs={parentFAQs} tabContentValue="parents" />
					<FAQ faqs={doulaFAQs} tabContentValue="doulas" />
				</Tabs>

			</div>
		</section>
	);
};

export default Faqs;